import React from 'react';

const MapPatterns = () => (
  <section className='eaMapPatterns' style={{ width: 0, height: 0 }}>
    <svg width='0' height='0'>
      <defs>
        <pattern id='diagonal4D0A42' width='10' height='10' patternTransform='rotate(-45 0 0)' patternUnits='userSpaceOnUse'>
          <rect x='0' y='0' width='10' height='10' style={{ fill: '#4D0A42' }} />
          <line x1='0' y1='0' x2='0' y2='10' style={{ stroke: '#F8F5F2', strokeWidth: 2 }} />
        </pattern>
        <pattern id='diagonalCA6FBA' width='10' height='10' patternTransform='rotate(-45 0 0)' patternUnits='userSpaceOnUse'>
          <rect x='0' y='0' width='10' height='10' style={{ fill: '#CA6FBA' }} />
          <line x1='0' y1='0' x2='0' y2='10' style={{ stroke: '#F8F5F2', strokeWidth: 2 }} />
        </pattern>
        <pattern id='diagonalE4B7DC' width='10' height='10' patternTransform='rotate(-45 0 0)' patternUnits='userSpaceOnUse'>
          <rect x='0' y='0' width='10' height='10' style={{ fill: '#E4B7DC' }} />
          <line x1='0' y1='0' x2='0' y2='10' style={{ stroke: '#F8F5F2', strokeWidth: 2 }} />
        </pattern>
      </defs>
    </svg>
  </section>
);

export default React.memo(MapPatterns);